<template>
  <Modal 
    ref="conditionsModalRef"
    @onNegativeActionClick="closeModal"
    class="conditions-modal"
    :showIcon="false"
    :withCloser="true"
    :modalStyle="{ width: '908px', padding: '20px' }"
  >
    <template v-slot:body>
      <div class="conditions-modal-content">
        <div class="section-top">
          <h2 class="main-title">Erken ödeme koşullarını nasıl sağlarım?</h2>
          <p class="description">Aşağıdaki koşullar sağlandığında ve aktif bir erken ödeme talebinizin bulunmaması durumunda erken ödeme talebi oluşturabilirsiniz.</p>
          
          <ConditionsModalStatuses :storeScore="storeScore" :paymentCount="paymentCount" />
        </div>
        
        <div class="section-bottom">
          <h3 class="section-title">Mağaza puanımı nasıl yükseltirim?</h3>
          <p class="section-description">Sipariş yönetimi, müşteri iletişimi ve teslimat performansınız ile ilgili aşağıdaki adımlar, puanınızı korumanıza ve yükseltmenize yardımcı olur.</p>
          
          <div class="info-cards">
            <div class="info-card">
              <div class="icon-title">
                <Icons name="Help" class="card-icon-40" color="#1C1C1E" />
                <h4>Müşteri sorularını en geç 24 saat içinde yanıtlayın</h4>
              </div>
              <p>Hızlı geri dönüşler, müşteri memnuniyetini artırır ve iletişim performansınıza olumlu yansır.</p>
            </div>
            
            <div class="info-card">
              <div class="icon-title">
                <Icons name="CloseCircleLg" class="card-icon-40" color="#1C1C1E" />
                <h4>Siparişleri reddetmekten kaçının</h4>
              </div>
              <p>Reddedilen siparişler puanınızı doğrudan olumsuz etkiler. Stok ve teslimat planlamasını doğru yapın.</p>
            </div>
            
            <div class="info-card">
              <div class="icon-title">
                <Icons name="TimerCircle" class="card-icon-40" color="#1C1C1E" />
                <h4>Siparişleri zamanında kargolayın</h4>
              </div>
              <p>Taahhüt edilen süre içinde kargolanan siparişler, teslimat performansınızı güçlendirir.</p>
            </div>
            
            <div class="info-card">
              <div class="icon-title">
                <Icons name="AlarmClock" class="card-icon-40" color="#1C1C1E" />
                <h4>Siparişlerin geciken kargolamaya düşmemesine özen gösterin</h4>
              </div>
              <p>Gecikmeler, hem müşteri memnuniyetini düşürür hem de puan kaybına neden olur.</p>
            </div>
            
            <div class="info-card">
              <div class="icon-title">
                <Icons name="PackageBox" class="card-icon-40" color="#1C1C1E" />
                <h4>Ürünlerin hasarsız ve eksiksiz gönderimini sağlayın</h4>
              </div>
              <p>Doğru paketleme sayesinde iade talepleri azalır, satış sonrası performansınız yükselir.</p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { ref } from 'vue';
import { Modal, Icons } from '@n11/so-ui-components';
import ConditionsModalStatuses from './ConditionsModalStatuses.vue';

export default {
  name: "ConditionsModal",
  components: {
    Modal,
    Icons,
    ConditionsModalStatuses,
  },
  props: {
    storeScore: {
      type: [Number, null],
      default: null
    },
    paymentCount: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const conditionsModalRef = ref(null);
    
    const openModal = () => {
      if (conditionsModalRef.value) {
        conditionsModalRef.value.openModal();
      }
    };
    
    const closeModal = () => {
      if (conditionsModalRef.value) {
        conditionsModalRef.value.closeModal();
      }
    };
    
    return {
      conditionsModalRef,
      openModal,
      closeModal,
      storeScore: props.storeScore,
      paymentCount: props.paymentCount,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.conditions-modal {
  :deep(.modal-body) {
    padding: 0 !important;
    text-align: left !important;
    width: 100% !important;
    max-height: unset !important;

    .content {
      text-align: left !important;
      align-items: flex-start !important;
      width: 100% !important;
    }
  }

  :deep(.modal-footer) {
    display: none !important;
  }
}

.conditions-modal-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  width: 100%;
}

.section-top,
.section-bottom {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  .description,
  .section-description {
    align-self: stretch;
    color: $colorN80;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.05px;
    margin: 0;
  }
}

.section-top {
  padding-bottom: 16px;
  border-bottom: 0.5px solid $colorN40;

  .main-title {
    align-self: stretch;
    color: $colorN80;
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: -0.2px;
    margin-top: 24px;
  }
}

.section-bottom {
  .section-title {
    color: $colorN80;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: -0.05px;
    margin: 0;
  }
}

.condition-boxes {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  gap: 16px;
}

.info-cards {
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 6px;
  flex-wrap: wrap;

  .info-card {
    display: flex;
    flex: 0 0 calc(33.33% - 11px);
    height: 192px;
    padding: 24px;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
    border: 1px solid $colorN40;
    background: $colorN00;

    .icon-title {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 12px;

      .card-icon-40 {
        :deep(svg) {
          width: 40px;
          height: 40px;
        }
      }

      h4 {
        color: $colorN80;
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        line-height: 18px;
        letter-spacing: -0.05px;
        margin: 0;
      }
    }

    p {
      align-self: stretch;
      color: $colorN70;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      margin: 0;
    }
  }
}
</style>
